module.exports = __webpack_public_path__ + "static/dp-tidslinjen-teaser-9826ba01864322c5a80dc0dfa3e3de61.jpg";